import { Link } from 'react-router-dom';
import { useI18n } from '@/features/i18n/I18nProvider';

const year = new Date().getFullYear();

export function MarketingFooter() {
  const { t } = useI18n();

  return (
    <footer className="mkt-footer">
      <div className="mkt-wrap">
        <div className="mkt-footer-grid">
          <div className="mkt-footer-brand">
            <Link to="/" className="mkt-footer-logo-link" aria-label={t('mkt.nav.homeAria')}>
              <img src="/logo-isbd.png" alt="ISBD" className="mkt-footer-logo" />
            </Link>
            <p className="mkt-footer-tagline">{t('mkt.footer.tagline')}</p>
            <div className="mkt-footer-cta">
              <Link to="/inscription" className="btn btn-accent">
                {t('mkt.footer.createAccount')}
              </Link>
              <Link to="/connexion" className="btn btn-ghost mkt-footer-ghost">
                {t('mkt.footer.login')}
              </Link>
            </div>
          </div>

          <nav className="mkt-footer-col" aria-label={t('mkt.footer.discover')}>
            <h2>{t('mkt.footer.discover')}</h2>
            <ul>
              <li>
                <Link to="/presentation">{t('mkt.footer.presentation')}</Link>
              </li>
              <li>
                <a href="/#parcours">{t('mkt.footer.parcours')}</a>
              </li>
              <li>
                <a href="/#offres">{t('mkt.footer.offres')}</a>
              </li>
              <li>
                <a href="/#equipe">{t('mkt.footer.equipe')}</a>
              </li>
            </ul>
          </nav>

          <nav className="mkt-footer-col" aria-label={t('mkt.footer.services')}>
            <h2>{t('mkt.footer.services')}</h2>
            <ul>
              <li>
                <Link to="/marketplace">{t('mkt.footer.marketplace')}</Link>
              </li>
              <li>
                <a href="/#concours">{t('mkt.footer.concours')}</a>
              </li>
              <li>
                <Link to="/contact">{t('mkt.footer.contact')}</Link>
              </li>
              <li>
                <Link to="/inscription">{t('mkt.footer.register')}</Link>
              </li>
            </ul>
          </nav>

          <nav className="mkt-footer-col" aria-label={t('mkt.footer.legal')}>
            <h2>{t('mkt.footer.legal')}</h2>
            <ul>
              <li>
                <Link to="/politique-de-confidentialite">{t('mkt.footer.privacy')}</Link>
              </li>
              <li>
                <Link to="/conditions-d-utilisation">{t('mkt.footer.terms')}</Link>
              </li>
              <li>
                <Link to="/contact">{t('mkt.footer.writeUs')}</Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mkt-footer-bottom">
          <p>{t('mkt.footer.rights', { year })}</p>
          <p className="mkt-footer-domain">isbd360.com</p>
        </div>
      </div>
    </footer>
  );
}
